// Las tres páginas de Confianza (nov-2026; Conservación unida a Firma el 4-nov), para la franja «Más sobre confianza»
// del final de cada una. Rutas en español: getLocalizedUrl las lleva a /en/trust/...
export const TRUST_PAGES = {
  es: [
    { key: 'firma', title: 'Firma y evidencias', text: 'Firma avanzada conforme a eIDAS, evidencias y conservación.', path: '/confianza/firma-electronica' },
    { key: 'seguridad', title: 'Seguridad', text: 'Certificación ENS, cifrado y control de accesos.', path: '/confianza/seguridad' },
    { key: 'cumplimiento', title: 'Cumplimiento normativo', text: 'Las normas que cumple cada documento.', path: '/confianza/cumplimiento-normativo' },
  ],
  en: [
    { key: 'firma', title: 'Signature and evidence', text: 'Advanced signature under eIDAS, evidence and preservation.', path: '/confianza/firma-electronica' },
    { key: 'seguridad', title: 'Security', text: 'ENS certification, encryption and access control.', path: '/confianza/seguridad' },
    { key: 'cumplimiento', title: 'Regulatory compliance', text: 'The rules every document complies with.', path: '/confianza/cumplimiento-normativo' },
  ],
};

export const RELATED_TITLE = { es: 'Más sobre confianza', en: 'More on trust' };

/** Las otras páginas, con la ruta ya localizada. */
export const otherTrustPages = (lang, current, getLocalizedUrl) =>
  TRUST_PAGES[lang].filter((p) => p.key !== current).map((p) => ({ title: p.title, text: p.text, to: getLocalizedUrl(p.path) }));
